import React, { Component } from 'react';
import { ErrorMessage, Field, Form, Formik } from 'formik';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import axios from 'axios';
import CustomLoader from '../../../common/CustomLoader';
import CustomSelect from '../../../../common/formElements/CustomSelect';
import * as actions from '../../redux/actions';
import { getSnippetModalOptions, validateSubmitBtn } from '../../ActionFormUtils';
import FormFieldWithLabel from '../../../common/FormFieldWithLabel';
import {
  createActionSettingsSchema,
  getFieldInfoByName,
  validateFormDataSessionKey,
  validateItemIdBSLKey,
  validateResponseDataSessionKey,
} from '../collection/Util';
import { builderSurfaceJsonContentHeader } from '../../../../common/utils/restApiHeaderUtils';
import BrowserStorageLocationField from '../BrowserStorageLocationField';
import { SNIPPET_TYPES } from 'drapcode-constant';
import { validationForFloatingModal } from '../../../../common/formElements/CollectionSectionType';
import { getItemIdFromOptions } from '../../../../common/utils/event_constants';
import FloatingModalProperties from './FloatingModalProperties';

class FloatingModal extends Component {
  state = {
    showFMProperties: false,
  };

  componentDidMount() {
    const { projectId, version } = this.props;
    console.log(
      '🚀 ~ FloatingModal ~ componentDidMount - projectId:',
      projectId,
      'version:',
      version,
    );
  }

  RESET_ITEM_ID_FROM_VALUES = [
    'sendCurrentObjectID',
    'sendPreviousStepParentCollectionId',
    'sendCurrentPageItemId',
    'sendCurrentUserId',
    'sendTargetItemID',
    'sendCurrentPageReferenceItemId',
  ];

  GET_ITEM_ID_FROM_OPTIONS_DESC = `
  <ul>
    <li>
      <b>Current Item ID -</b> Get the recently created or updated Collection
      Item ID.
    </li>
    <li>
      <b>Item ID from Previous Step -</b> Get the Collection's Item ID, which was
      recorded in the previous step.
    </li>
    <li>
      <b>Item ID of Current Page -</b> Get the Collection's Item ID from the
      Current Page URL.
    </li>
    <li>
      <b>Item ID from Browser Storage Location -</b> Get the Collection's Item ID
      from the Browser storage location (Default: Session Storage).
    </li>
  </ul>
    `;

  getCustomFunctionFromApi = async (projectId, version) => {
    const uri = `${process.env.REACT_APP_BUILDER_ENGINE}custom-function/`;
    const header = builderSurfaceJsonContentHeader(projectId);
    return axios.get(uri, header);
  };

  floatingModalOptions = () => {
    const { snippets } = this.props.events;
    let options = getSnippetModalOptions(snippets, SNIPPET_TYPES.FLOATING_MODAL);
    return options;
  };

  getItemIdFromOptions = () => {
    let options = getItemIdFromOptions;
    return options;
  };

  handleSubmit = (values) => {
    const { actionData, version, projectId, actions, selectedEvent } = this.props;
    let parameters = [];
    const hasGetItemIdFrom = !!values['getItemIdFrom'];

    Object.keys(values).forEach((value) => {
      const action = actionData.args.find((param) => param.name === value);
      if (action) {
        parameters.push({
          name: value,
          value:
            hasGetItemIdFrom && this.RESET_ITEM_ID_FROM_VALUES.includes(value) ? '' : values[value],
          type: action.type,
        });
      }
    });

    let actionFormData = this.props.eventAction;
    actionFormData.parameters = parameters;

    console.log('🚀 ~ FloatingModal ~ Calling updateAction with:', {
      projectId,
      version,
      eventId: selectedEvent && selectedEvent.uuid,
      data: actionFormData,
    });

    actions
      .updateAction({
        projectId,
        version,
        eventId: selectedEvent && selectedEvent.uuid,
        data: actionFormData,
      })
      .then(() => {
        this.props.hideModal();
      })
      .catch((error) => {
        console.error('🚀 ~ FloatingModal ~ Action update failed:', error);
      });
  };

  renderGetItemIdFrom = (setFieldValue, setFieldTouched, values) => {
    return (
      <div className="form-group">
        <FormFieldWithLabel
          cta={false}
          label="Get Item ID From"
          icon="select"
          infoIcon={true}
          infoDescription={this.GET_ITEM_ID_FROM_OPTIONS_DESC}
        >
          <CustomSelect
            name={'getItemIdFrom'}
            isMulti={false}
            onChange={setFieldValue}
            onBlur={setFieldTouched}
            options={this.getItemIdFromOptions()}
            value={values['getItemIdFrom']}
          />
          <ErrorMessage name={'getItemIdFrom'}>
            {(msg) => <p className="text-error">{msg}</p>}
          </ErrorMessage>
        </FormFieldWithLabel>
      </div>
    );
  };

  isSendBSLItemIdEnabled = (values) => {
    return values['getItemIdFrom'] === 'sendBSLItemId';
  };

  FMPropertiesOptionHandler = () => {
    this.setState({
      showFMProperties: !this.state.showFMProperties,
    });
  };

  showAlertMessage = () => {
    return (
      <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12">
        <div className="alert alertWarning">
          <div className="alert-icon">
            <i
              className="wb webconnect-exclamation-circle-fill"
              style={{ verticalAlign: '1px' }}
            ></i>
          </div>
          Limited support for the Mozilla Firefox browser.
        </div>
      </div>
    );
  };

  render() {
    const { eventAction, actionData } = this.props;
    const { showFMProperties } = this.state;

    return (
      <Formik
        enableReinitialize={true}
        initialValues={createActionSettingsSchema(actionData, eventAction)}
        validationSchema={validationForFloatingModal()}
        onSubmit={(values, { setSubmitting, resetForm }) => {
          this.handleSubmit(values);
          setSubmitting(false);
          resetForm();
        }}
      >
        {({ isSubmitting, values, setFieldValue, setFieldTouched, errors }) => (
          <Form>
            <div className="row">
              <div className="col-12">
                <div className="form-group">
                  <FormFieldWithLabel
                    cta={false}
                    label="Floating Modal"
                    icon="select"
                    infoIcon={true}
                    infoDescription={getFieldInfoByName('floatingModalId')}
                  >
                    <CustomSelect
                      name="floatingModalId"
                      isMulti={false}
                      onChange={(name, value) => {
                        setFieldValue(name, value);
                      }}
                      onBlur={setFieldTouched}
                      options={this.floatingModalOptions()}
                      value={values['floatingModalId']}
                      placeholder="Select Floating Modal"
                    />
                    <ErrorMessage name="floatingModalId">
                      {(msg) => <p className="text-error">{msg}</p>}
                    </ErrorMessage>
                  </FormFieldWithLabel>
                </div>
                {/* Get Item ID From Section */}
                {this.renderGetItemIdFrom(setFieldValue, setFieldTouched, values)}
                {this.isSendBSLItemIdEnabled(values) && (
                  <>
                    <BrowserStorageLocationField
                      fieldName={'browserStorageLocation'}
                      values={values}
                      description={
                        'Select a browser storage location to get an Item ID key (Default: Session Storage).'
                      }
                      setFieldValue={setFieldValue}
                      setFieldTouched={setFieldTouched}
                    />
                    <div className="form-group">
                      <FormFieldWithLabel
                        cta={false}
                        label="Browser Storage Key"
                        icon="text"
                        infoIcon={true}
                        infoDescription={`Enter the key which contains Item ID value in your web browser storage.`}
                      >
                        <Field
                          type="text"
                          name="browserStorageItemIdPath"
                          className="form-control form-control-sm"
                          autoComplete="off"
                          placeholder="Item ID JSON Key Eg. Key1 or, Parent_Key1.Child_Key[0]"
                          validate={validateItemIdBSLKey}
                        />
                      </FormFieldWithLabel>
                      <ErrorMessage name={'browserStorageItemIdPath'}>
                        {(msg) => <p className="text-error ml-5">{msg}</p>}
                      </ErrorMessage>
                    </div>
                  </>
                )}
                <div className="form-group">
                  <button
                    onClick={(e) => this.FMPropertiesOptionHandler(e)}
                    className="btn btn-icon-only btn-outline-info ml-5 p-1"
                    title="Show Modal Properties"
                    type="button"
                  >
                    <i className="wb webconnect-cog"></i>&nbsp;Modal Properties
                  </button>
                </div>
                {showFMProperties && (
                  <FloatingModalProperties
                    setFieldValue={setFieldValue}
                    setFieldTouched={setFieldTouched}
                    values={values}
                  />
                )}
              </div>
            </div>
            {this.showAlertMessage()}
            <div className="row">
              <div className="col-md-6 text-left">
                <button
                  type="button"
                  className="btn btn-outline-secondary btn-sm"
                  onClick={() => {
                    this.props.hideModal();
                  }}
                >
                  <span>
                    <i className="wb webconnect-times"></i> Cancel
                  </span>
                </button>
              </div>
              <div className="col-md-6 text-right">
                <button
                  type="submit"
                  disabled={validateSubmitBtn(values, eventAction) || isSubmitting}
                  className={`btn btn-sm ${
                    validateSubmitBtn(values, eventAction) || isSubmitting
                      ? 'btn-default'
                      : 'btn-theme-submit'
                  }`}
                >
                  <i className="wb webconnect-save-regular"></i> Save
                  <CustomLoader loading={this.props.showLoaderForAction} />
                </button>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    );
  }
}

function mapStateToProps(state) {
  return { event: state.event };
}

function mapDispatchToProps(dispatch) {
  return { actions: bindActionCreators({ ...actions }, dispatch) };
}

export default connect(mapStateToProps, mapDispatchToProps)(FloatingModal);
